import { render, staticRenderFns } from "./HeroText.vue?vue&type=template&id=39e55337&scoped=true&"
var script = {}
import style0 from "./HeroText.vue?vue&type=style&index=0&id=39e55337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e55337",
  null
  
)

export default component.exports